<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <div class="page-group-title"><span>基础设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="活动封面:">
                        <image-upload :url.sync="formData.poster" :urlFull.sync="formData.poster" :crop="true" :width="1005"
                            :height="540" ref="posterUpload" class="poster-upload" @onSuccess="handleImageSuccess">
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="活动名称:">
                        <el-input v-model="formData.name" placeholder="请填写活动名称" :maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item prop="datetimerange" label="活动有效期:">
                        <el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始时间"
                            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" unlink-panels></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="h5ResourceId">
                        <span slot="label">H5页面资源ID: <small>每个阶段需要上传的素材，请到H5页面配置进行管理</small></span>
                        <el-input-number v-model="formData.h5ResourceId" :min="0" :precision="0" style="width:100%"
                            :controls="false"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="onTime" label="上线时间:" :rules='[{required: true, message: "请填写上线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.onTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>						
						<small><span class="el-icon-warning"></span>上线前乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="offTime" label="下线时间:" :rules='[{required: true, message: "请填写下线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.offTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<small><span class="el-icon-warning"></span>下线后乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			</el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="command" label="活动口令:">
                        <el-input v-model="formData.command" placeholder="自定义活动口令" type="textarea" show-word-limit
                            maxlength="100"></el-input>
                        <div><span class="color-info">生成口令样例：</span>&&****&&{{ formData.command }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="rule" label="活动规则:">
                        <tinymce v-model="formData.rule" :height="400" :toolbar="toolbar" :menubar="false" v-if="reFresh">
                        </tinymce>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>奖励设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="couponRuleId" label="绑定优惠券:">
                        <el-input v-model="formData.couponRuleId" placeholder="请输入优惠券ID" :maxlength="20"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="initPriceStr">
                        <span slot="label">初始金额（元）: <small>初始获得奖励金额</small></span>
                        <el-input-number v-model="formData.initPriceStr" :min="0" :max="99999" :precision="0"
                            style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="userPriceStr">
                        <span slot="label">浮动金额（元）: <small>每多一个有效邀请人，在初始金额的基础上增加的金额</small></span>
                        <el-input-number v-model="formData.userPriceStr" :min="0" :max="99999" :precision="0"
                            style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="limitPriceStr">
                        <span slot="label">上限金额（元）: <small>每个用户最多可以获得的奖励金额</small></span>
                        <el-input-number v-model="formData.limitPriceStr" :min="0" :max="99999" :precision="0"
                            style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>阶段配置</span><el-button type="primary" plain size="mini" icon="el-icon-plus"
                    @click="$refs.stageEdit.show()">增加阶段</el-button></div>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="stageList">
                        <el-table :data="formData.stageList" border style="width: 100%" size="mini" stripe>
                            <el-table-column prop="stage" label="阶段"></el-table-column>
                            <el-table-column prop="number" label="解锁人数"></el-table-column>
                            <el-table-column prop="pic" label="图片">
                                <template slot-scope="scope"><el-image v-if="scope.row.pic"
                                        :src="scope.row.pic | coverImage(120, 120)"
                                        :preview-src-list="[scope.row.pic]"></el-image></template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作">
                                <template v-if="scope" slot-scope="scope">
                                    <el-button type="text" @click="$refs.stageEdit.show(scope.row)">编辑</el-button>
                                    <el-button v-if="scope.$index > 0" type="text"
                                        @click="stageDel(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="initJoinNum">
                        <span slot="label">虚拟活动人数: <small>乐迷端显示参与人数 = 虚拟活动人数 + 真实参与人数</small></span>
                        <el-input-number v-model="formData.initJoinNum" :min="0" :max="9999999" :precision="0"
                            style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
        <stage-edit ref="stageEdit" @onUpdate="stageUpdata"></stage-edit>
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import ImageUpload from '@/components/ImageUpload';
import StageEdit from './components/stageEdit.vue';
const defaultFormData = {
    name: "",
    datetimerange: null,
    startTime: null,
    endTime: null,
    onTime:'',
	offTime:'',
    rule: "",
    couponRuleId: "",
    initPriceStr: undefined,
    limitPriceStr: undefined,
    userPriceStr: undefined,
    poster: "",
    command: "复制查看",
    h5ResourceId: undefined,
    stageList: [{
        stage: 0,
        number: 0,
        pic: ''
    }],
    initJoinNum: 0
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components: { Tinymce, ImageUpload, StageEdit },
    data() {
        return {
            drawerShow: false,
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                name: [{ required: true, message: "请填写活动名称" }],
                datetimerange: [{ required: true, message: "请填写活动有效期" }],
                couponRuleId: [{ required: true, message: "请填写优惠券ID" }],
                initPriceStr: [{ required: true, message: "请设置初始金额" }],
                limitPriceStr: [{ required: true, message: "请设置金额上限" }],
                userPriceStr: [{ required: true, message: "请设置浮动金额" }],
                poster: [{ required: true, message: "请上传活动封面" }],
                h5ResourceId: [{ required: true, message: "请上填写H5资源ID" }],
            },
            toolbar: ['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            reFresh: false,
            redirect: this.$route.query.redirect || '/promotion/unlockPoster/list',
            newStageList: []
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
        } else {
            this.formData = {
                ...defaultFormData,
                stageList: [{
                    stage: 0,
                    number: 0,
                    pic: ''
                }]
            }
            this.reFresh = true;
        }
    },
    methods: {
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/unlock/poster/info",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            datetimerange: result.startTime ? [result.startTime, result.endTime] : [],
                        };
                        this.formData.stageList.map((v,i) => v.stage = i)
                        this.reFresh = true;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess() {
            if (this.formData.poster) {
                this.$refs["formData"].clearValidate('poster');
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    if (this.formData.limitPriceStr <= this.formData.initPriceStr) {
                        this.$message.error('上限金额必须大于初始金额');
                        return;
                    }
                    this.btnLoading = true;

                    this.$request({
                        url: '/unlock/poster/save',
                        data: {
                            ...this.formData,
                            startTime: this.formData.datetimerange[0],
                            endTime: this.formData.datetimerange[1],
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
        //编辑阶段
        stageUpdata(e) {
            console.log(e)
            const stage = e.stage, index = this.formData.stageList.findIndex(v => v.stage === stage);
            if (index != -1) {
                this.$set(this.formData.stageList, index, e)
            } else {
                this.formData.stageList.push({
                    ...e,
                    stage: this.formData.stageList.length
                })
            }
        },
        stageDel(index) {
            this.formData.stageList = this.formData.stageList.filter((v, i) => i !== index);
        },
    }
}
</script>

<style lang="scss" scoped>.el-image {
    width: 60px;
}</style>